import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    // Check if the screen is mobile
    this.isMobile = window.innerWidth < 900

    this.filters = gsap.utils.toArray('.filterType')
    this.items = gsap.utils.toArray('.filterItem')
    this.grid = this.el.querySelector('.filterGrid')
    this.loadmore = this.el.querySelector('.filterMore')

    // Set default state
    this.isAnimating = false
    this.active = this.isMobile
      ? 4
      : parseInt(this.el.getAttribute('data-active'))
    this.filter = 'all'

    this.updateFilters(this.filter)
    this.initEventListeners()
  }

  initEventListeners() {
    this.filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.isAnimating) return
        this.setFilterActive(btn)

        this.filter = btn.getAttribute('data-filter')
        this.updateFilters(this.filter)
      })
    })

    this.loadmore.addEventListener('click', () => {
      if (this.isAnimating) return
      this.active = this.active + 4
      this.updateFilters(this.filter)
    })
  }

  updateFilters(filter) {
    this.isAnimating = true

    // First
    const matches =
      filter === 'all'
        ? this.items
        : this.items.filter((el) =>
            el.getAttribute('data-filter').includes(filter)
          )

    // Last
    this.items.forEach((item, i) => {
      item.classList.add('hidden')
    })

    matches.forEach((item, i) => {
      if (i < this.active) {
        item.classList.remove('hidden')
        this.loadImage(item)
      }
    })

    this.checkLoadmoreBtn(matches.length)
    this.isAnimating = false
  }

  loadImage(element) {
    const img = element.querySelector('img')
    const src = img.getAttribute('data-src')
    if (img.src !== src && src !== null) {
      img.src = src
    }
  }

  checkLoadmoreBtn(total) {
    if (this.active >= total) {
      this.loadmore.classList.add('hidden')
    } else {
      this.loadmore.classList.remove('hidden')
    }
  }

  setFilterActive(el) {
    this.filters.forEach((btn) => {
      btn.classList.remove('--active')
      btn.style.pointerEvents = 'auto'
    })
    el.classList.add('--active')
    el.style.pointerEvents = 'none'
  }
}
